import { getDownloadURL, ref } from "firebase/storage";

import { storage } from "../firebase";
import { rollbar } from "./rollbar";

export const STATE_NAMES = {
  NONE: "none",
  CLAIMED_BY_INVESTOR: "CLAIMED_BY_INVESTOR",
  CONFIRMED_BY_PROJECT: "CONFIRMED_BY_PROJECT",
  CANCELLED_BY_INVESTOR: "CANCELLED_BY_INVESTOR",
  CANCELLED_DUE_ERROR: "CANCELLED_DUE_ERROR",
};

export const TRANSITION_NAME = {
  CLAIM_BY_INVESTOR: "claimByInvestor",
  CONFIRM_BY_PROJECT: "confirmByProject",
  CANCEL_BY_INVESTOR: "cancelByInvestor",
  CANCEL_DUE_ERROR: "cancelDueError",
};

export const percentFromProject = (shares, poolSize, virtualShares) => {
  return (shares / (poolSize / 100) / 100) * virtualShares;
};

export const priceForShares = (share, pricePerShare) => {
  return share * pricePerShare;
};

export const downloadContract = (investment, onError = () => {}) => {
  getDownloadURL(ref(storage, investment.contractStorageRef))
    .then((url) => {
      window.open(url, "_blank");
    })
    .catch((e) => {
      rollbar.error(e);
      onError(e);
    });
};

export const contractState = (investment) => {
  let disabled, label;
  let showProgress = false;
  if (
    [
      STATE_NAMES.CANCELLED_BY_INVESTOR,
      STATE_NAMES.CANCELLED_DUE_ERROR,
    ].includes(investment.state)
  ) {
    disabled = true;
    label = "Investments.Detail:Investment contract removed";
  } else if (
    [
      STATE_NAMES.CLAIMED_BY_INVESTOR,
      STATE_NAMES.CONFIRMED_BY_PROJECT,
    ].includes(investment.state)
  ) {
    if (investment.contractStorageRef) {
      disabled = false;
      label = "Investments.Detail:Download investment contract";
    } else {
      disabled = true;
      showProgress = true;
      label = "Investments.Detail:Investment contract is being generated";
    }
  }

  return [label, disabled, showProgress];
};

export const QRPaymentFormat = (iban, ss, vs, amount, msg) => {
  return `SPD*1.0*ACC:${iban}*AM:${amount.toFixed(
    2
  )}*CC:CZK*MSG:${msg.toUpperCase()}*X-VS:${vs}*X-SS:${ss}`;
};
